// extracted by mini-css-extract-plugin
module.exports = {"full-width-image-form-item":"_2UlDtBkLgjM1E2XLTu4A"};